import React from 'react';

import { AwardGeneral } from '@travel/icons/award';
import { Close } from '@travel/icons/ui';
import Translate from '@travel/traveler-core/components/Translate';
import { useDeviceType, MOBILE_SCREEN } from '@travel/traveler-core/hooks';
import { FlatButton } from '@travel/ui';

import Dialog from '../Dialog';

import styles from './rakutenAwardPopup.module.scss';

type Props = {
  isOpen?: boolean;
  onClose?: () => void;
};

function RakutenAwardPopup(props: Props) {
  const { isOpen, onClose } = props;
  const isSP = useDeviceType() === MOBILE_SCREEN;

  return (
    <div>
      <Dialog
        isOpen={isOpen}
        isClosableByClickingOutside={true}
        onClose={onClose}
        className={styles.rakutenAwardDialog}
        contentClassName={styles.rakutenAwardContentBox}
        dialogWrapperClassName={styles.dialogWrapper}
        hasAnimation={true}
      >
        {!isSP && (
          <button
            className={styles.closePopup}
            onClick={onClose}
            aria-label="Close menu"
            data-testid="header-close-button"
          >
            <Close size={24} />
          </button>
        )}
        <div
          className={styles.rakutenAwardContentWrapper}
          data-testid="rakutenAwardContent-wrapper"
        >
          <AwardGeneral />
          <div className={styles.fontSize}>
            <div>
              <Translate id="Traveler_Common.Awards.Description1" />
            </div>
            <div>
              <Translate id="Traveler_Common.Awards.Description2" />
            </div>
          </div>

          <div>
            <FlatButton
              classType="primary"
              onClick={onClose}
              className={styles.closeButton}
              data-testid="rakutenAward-close-button"
            >
              <Translate id="Traveler_Common.Close" />
            </FlatButton>
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default React.memo(RakutenAwardPopup);
